<template>
    <div class="saas-feature section-space--ptb_30 gray-gradient">
        <div class="container">
            <div class="row pricing-section" v-if="!loaded">
                <div class="col-lg-12">
                    <h5 class="heading mb-10 text-center">{{ $t("pricing.loading") }}</h5>
                </div>
            </div>

            <div class="row pricing-section" v-for="(price, name) in items" :key="name" v-else>
                <div class="col-lg-6">
                    <h5 class="heading mb-10">{{ $t("home." + name) }}</h5>
                </div>
                <div class="col-lg-6">
                    <p class="description">{{ $t("home." + name + "_text") }}</p>
                    <a :href="links[name]" class="learn-more" target="_blank">{{ $t("pricing.learn_more") }}</a>

                    <p class="price" v-html="$t('pricing.tokens', {price: formatNumber(price / 100)})"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PricingList',
    data() {
        return {
            loaded: false,

            items: [],

            links: {
                lang: "language-detection",
                sent: "sentiment",
                summ: "text-summarization",
                tokn: "tokenizer",
                nert: "entity-recognition",
                keyw: "keywords"
            }
        };
    },
    methods: {
        formatNumber(number) {
            const format = this.$t("global.number_format");

            const formatter = new Intl.NumberFormat(format, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            return formatter.format(number);
        },
        async resolveItems() {
            try {
                const response = await fetch("https://app.trustami.ai/_api/apis");

                if (response && response.ok) {
                    const data = await response.json();

                    if (data && data.status) {
                        this.items = data.prices;
                    }
                }
            } catch (e) {
                // Something went wrong
            }

            this.loaded = true;
        }
    },
    mounted() {
        this.resolveItems();
    }
};
</script>
